/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_DescriptionInputs */

const en_admin_subscriptions_description = /** @type {(inputs: Admin_Subscriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all subscriptions`)
};

/**
* | output |
* | --- |
* | "View all subscriptions" |
*
* @param {Admin_Subscriptions_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_description = /** @type {((inputs?: Admin_Subscriptions_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_description(inputs)
});
export { admin_subscriptions_description as "admin.subscriptions.description" }